// extracted by mini-css-extract-plugin
module.exports = {"notes":"notes__3R3O9"};